import React from "react";
import ClickArrowIcon from "../../components/svgs/ClickArrowIcon";
import { getTouchPointImage } from "../../utils/imageService";

const WorkspaceItem = ({ client, onClick }) => {
  const clientImage = getTouchPointImage(client);
  return (
    <div onClick={onClick} className="workspace-item">
      <div className={clientImage ? "workspace-image" : "workspace-image no-image"}>
        {clientImage && <img src={clientImage} alt="" />}
      </div>
      <div className="workspace-name">{client.name}</div>
      <span className="click-icon">
        <ClickArrowIcon color={client?.altColor} />
      </span>
    </div>
  );
};

export default WorkspaceItem;
